import { defineComponent as _defineComponent } from 'vue'
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import AiIcon from '@/components/svg/ai-icon-large.png';
import Chevron from '@/components/svg-components/Chevron.vue';
import IconClose from '@/components/svg-components/X.vue';
import useI18n from '@/mixins/useI18n';
import useProfilePdfUploadPopup from '@/views/profile/composables/useProfilePdfUploadPopup';
import { useRouter } from 'vue2-helpers/vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfilePdfUploadBanner',
  props: {
    action: { default: 'open-popup' },
    dismissible: { type: Boolean, default: true },
    trailingIcon: { default: 'close' },
    titleKey: { default: 'profilePdfUpload.banner.title' }
  },
  setup(__props: any) {

const props = __props as { action: 'open-popup' | 'go-to-profile-and-open-popup', dismissible: boolean, trailingIcon: 'close' | 'chevron', titleKey: string };



const { t } = useI18n();
const router = useRouter();
const {
  open, dismissBanner, requestOpenOnProfileVisit, clearOpenOnProfileVisit
} = useProfilePdfUploadPopup();

const onClick = async () => {
  if (props.action === 'go-to-profile-and-open-popup') {
    requestOpenOnProfileVisit();
    try {
      await router.push({ name: 'profile' });
    } catch (error) {
      clearOpenOnProfileVisit();
      throw error;
    }
    return;
  }
  open();
};

return { __sfc: true,props, t, router, open, dismissBanner, requestOpenOnProfileVisit, clearOpenOnProfileVisit, onClick, BCXMarkdown, AiIcon, Chevron, IconClose }
}

})